//import { zodResolver } from '@hookform/resolvers/zod';
const { z } = require('zod');

export const generalResolver = 
  z.object({
    language: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    race: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    religion: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    employerName: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    employerAddr1: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    employerAddr2: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    employerCity: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    employerState: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    employerZip: z.optional(
      z.string().max(100, { message: 'Must be 100 or fewer characters long' })
    ).nullish(),
    allowVoiceMessage: z.optional(z.number().int()).nullish(),
    allowMailMessage: z.optional(z.number().int()).nullish(),
    allowEmailMessage: z.optional(z.number().int()).nullish(),
    allowSmsMessage: z.optional(z.number().int()).nullish(),
    allowHealthInfoExchange: z.optional(z.number().int()).nullish(),
    acceptHIPAANotice: z.optional(z.number().int()).nullish(),
  })

